import {
  useFormErrorNotification,
  useFormSuccessNotification,
} from "@babackapp/react-hook-forms-components/form-notifications";
import { useMutation } from "@tanstack/react-query";
import { $api } from "../generated/client";
import type { CreateOneWorkflowDto } from "../generated/schema";
import useInvalidateShop from "./use-invalidate-shop";
import { useInvalidateWorkflowListQuery } from "./use-workflows-query";

export default function useAddWorkflow(shopId: string) {
  const successNotification = useFormSuccessNotification();
  const errorNotification = useFormErrorNotification();
  const invalidateShop = useInvalidateShop(shopId);
  const invalidateWorkflowListQuery = useInvalidateWorkflowListQuery(shopId);

  const mutation = $api.useMutation("post", "/shops/{shopId}/workflows");

  return useMutation({
    onSuccess: () => {
      invalidateShop();
      invalidateWorkflowListQuery();
      successNotification();
    },
    onError: () => {
      errorNotification();
    },
    mutationFn: (body: CreateOneWorkflowDto) => {
      return mutation.mutateAsync({
        params: { path: { shopId } },
        body,
      });
    },
  });
}
